export const CONSTANT = {
  PIXERFECT_SOLUTIONS_LLP: 'Pixerfect Solutions LLP',
  PIXERFECT_WEB_LINK: 'https://www.pixerfect.com',
  PIXERFECT_HR_MAIL: 'hr.pixerfect@gmail.com',
  PIXERFECT_MAIL: 'info@pixerfect.com',
  PIXERFECT_MOBILE_NUMBER: '+91 63556 23396',
  BACKEND_API_URL: 'https://www.api.pixerfect.com',
  // BACKEND_API_URL: 'http://localhost:1337',
  MAP_API_KEY: 'AIzaSyB45deDJBtBnee8CnPE0IyRVpygnfjRLrM'
};

export const API_URL = {
  BLOG_CATEGORIES: '/api/blog-categories',
  BLOGS: '/api/blogs?populate=*',
  CONTACTS: '/api/contacts',
  CAREERS: '/api/carriers',
  NEWS_LETTER: '/api/news-letters'
};

export const SEO = {
  // Home
  HOME_PAGE_TITLE: `Top Web & Mobile App Development Company | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  HOME_PAGE_DESCRIPTION: `Top software development company in Surat, India. Custom web & mobile apps trusted by 150+ global clients with 300+ successful projects delivered.`,
  HOME_PAGE_KEYWORDS: `Pixerfect, Software Development, Website, Application, Game, Digital Marketing, Design, UI UX, AI, Cloud, AWS, Custom Software, App Development`,

  // Projects
  PROJECTS_PAGE_TITLE: `Case Studies & Portfolio of IT Projects | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  PROJECTS_PAGE_DESCRIPTION: `Explore 300+ successful projects by ${CONSTANT.PIXERFECT_SOLUTIONS_LLP} — our wall of pride showcasing custom web & mobile applications.`,
  PROJECT_PAGE_KEYWORDS: `Case Studies, IT Services, Cloud Computing, Web Development, Mobile App Development, Software Development, E-Commerce, CRM, Android App, Enterprise Solutions`,

  // Services
  SERVICES_PAGE_TITLE: `Web, Mobile, AI & Cloud Services Company | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  SERVICES_PAGE_DESCRIPTION: `${CONSTANT.PIXERFECT_SOLUTIONS_LLP} offers web, mobile, AI, game development, digital marketing, and Cloud & AWS services in Surat, India.`,
  SERVICES_PAGE_KEYWORDS: `Web Development, Mobile App, AI Development, Game Development, Digital Marketing, Cloud, AWS, Software Services, IT Company Surat`,

  // Career
  CAREER_PAGE_TITLE: `Careers & Hiring Developers in IT Company | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  CAREER_PAGE_DESCRIPTION: `Join ${CONSTANT.PIXERFECT_SOLUTIONS_LLP} or hire expert developers for your project. We provide skilled tech professionals for custom software solutions.`,
  CAREER_PAGE_KEYWORDS: `Hire Developers, Software Jobs, IT Careers, Web Developer Jobs, Mobile App Developer, Tech Jobs Surat, Software Company Careers`,

  // Our Team
  OUR_TEAM_PAGE_TITLE: `Meet Our Expert Team of Developers & Designers | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  OUR_TEAM_PAGE_DESCRIPTION: `Meet the skilled developers, designers, and testers at ${CONSTANT.PIXERFECT_SOLUTIONS_LLP} — dedicated individuals and teams built for your success.`,
  OUR_TEAM_PAGE_KEYWORDS: `Software Developers, Designers, Testers, Dedicated Team, IT Professionals, Tech Team Surat, App Developers`,

  // About Us
  ABOUT_US_PAGE_TITLE: `About Our Software Company & Mission | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  ABOUT_US_PAGE_DESCRIPTION: `Learn how ${CONSTANT.PIXERFECT_SOLUTIONS_LLP} became a leading web & tech company in Surat. Discover our story, mission, values, and vision.`,
  ABOUT_US_PAGE_KEYWORDS: `About Pixerfect Solutions, Our Story, Mission, Vision, Core Values, Leadership Team, Founders, Company Overview, Why Choose Pixerfect`,
  // Testimonials
  TESTIMONIAL_PAGE_TITLE: `Client Reviews & Testimonials for IT Services | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  TESTIMONIAL_PAGE_DESCRIPTION: `Read what 150+ global clients say about ${CONSTANT.PIXERFECT_SOLUTIONS_LLP} — web, mobile, AI, game development & digital marketing reviews.`,
  TESTIMONIAL_PAGE_KEYWORDS: `Client Testimonials, Customer Reviews, User Feedback, Success Stories, Client Satisfaction, App Development Reviews, Web Development Feedback`,
  // Blog
  BLOG_PAGE_TITLE: `Tech Blog on Web, Mobile & AI Trends | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  BLOG_PAGE_DESCRIPTION: `Stay updated with the latest tech insights, trends, and tips from the experts at ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}.`,
  BLOG_PAGE_KEYWORDS: `Tech Blog, Web Development, Mobile App, AI Development, Game Development, Digital Marketing, Cloud Computing, Software Development, IT Services, Tech Trends`,

  BLOG_DETAILS_PAGE_TITLE: `Detailed Tech Guides & Insights Blog | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  BLOG_DETAILS_PAGE_DESCRIPTION: `Dive deeper into tech topics, development guides, and industry insights shared by ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}'s expert team.`,
  BLOG_DETAILS_PAGE_KEYWORDS: `Tech Blog, Web Development, Mobile App, AI Development, Game Development, Digital Marketing, Cloud Computing, Software Development, IT Services, Tech Trends`,
  // Contact Us
  CONTACT_PAGE_TITLE: `Contact IT Company for Web & App Development | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  CONTACT_PAGE_DESCRIPTION: `Get in touch with ${CONSTANT.PIXERFECT_SOLUTIONS_LLP} for custom web & mobile app development services and software solutions in Surat, India.`,
  CONTACT_PAGE_KEYWORDS: `Contact Pixerfect Solutions, Software Company Surat, Web Development Inquiry, Mobile App Services, Get In Touch, Custom Software Contact`,
  // Legal
  TOS_PAGE_TITLE: `Terms of Service & Usage Policies | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  TOS_PAGE_DESCRIPTION: `Read the Terms of Service for ${CONSTANT.PIXERFECT_SOLUTIONS_LLP} to understand usage policies, rights, and responsibilities on our platform.`,
  TOS_PAGE_KEYWORDS: `Terms of Service, Usage Policies, Rights, Responsibilities, Platform Usage, Legal Agreement`,

  PRIVACY_POLICY_PAGE_TITLE: `Privacy Policy & Data Protection Details | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  PRIVACY_POLICY_PAGE_DESCRIPTION: `Learn how ${CONSTANT.PIXERFECT_SOLUTIONS_LLP} collects, uses, and protects your personal data. Your privacy and security matter to us.`,
  PRIVACY_POLICY_PAGE_KEYWORDS: `Privacy Policy, Data Protection, Personal Information, Data Collection, Security Measures, Privacy Rights`,
  // Not Found
  NOT_FOUND_PAGE_TITLE: `Page Not Found - Explore Our IT Services | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`,
  NOT_FOUND_PAGE_DESCRIPTION: `Oops! The page you're looking for doesn't exist. Head back to ${CONSTANT.PIXERFECT_SOLUTIONS_LLP} and explore our web & mobile app services.`
};

export const trimForSEO = (str, maxLength = 150) => {
  if (str.length <= maxLength) return str;

  let trimmed = str.slice(0, maxLength);

  // avoid cutting mid-word
  trimmed = trimmed.slice(0, trimmed.lastIndexOf(' '));

  return trimmed + '...';
};
